import isUrl from 'is-url'
import { useClipboard } from '@vueuse/core'

const PurchaseResponseMixin = {
  setup() {
    const { copy } = useClipboard()
    return {
      copy,
    }
  },
  methods: {
    async handlePurchaseResponse({
      fawry, message, payment_url, url,
    }, source) {
      const paymentUrl = payment_url || url

      if (fawry && paymentUrl) {
        return this.handleFawry(paymentUrl)
      }

      if (this.payment_method === 'wiretransfer') {
        return this.handleWireTransfer()
      }

      if (!isUrl(paymentUrl)) {
        return this.handlePaymentSucceed(message, source)
      }

      window.location.href = paymentUrl
      return 'REDIRECT'
    },
    async handleFawry(paymentUrl) {
      await this.$swalSuccess('Fawry ID', {
        titleText: paymentUrl,
        message: 'Fawry ID',
        confirmButtonText: this.$t('forms.copy'),
        timer: null,
      })
      await this.copy(paymentUrl)
      this.$notifySuccess(this.$t('forms.copied'))
      return 'PENDING'
    },
    async handleWireTransfer() {
      await this.$swalSuccess('', {
        titleText: this.$t('payment.wiretansfer-successfully-sent'),
        message: '',
        confirmButtonText: this.$t('forms.ok'),
        timer: null,
      })
      return 'PENDING'
    },
    async handlePaymentSucceed(message = '', source = '') {
      const features = (this.features ?? []).map(f => f.slug).join(',')
      const query = {
        message, payment: 'succeed', plan: this.plan?.slug, features,
      }
      const route = ['upgrade', 'invoice', 'plans', 'public-invoice'].includes(source) ? { name: 'payment:succeed', query } : { query }

      if (!this.$store.getters['auth/isAuthenticated']) {
        await this.$router.push(route).catch(error => console.error(error))
        return 'SUCCESS'
      }

      if (this.$store.getters['pricing/pricesFetched']) {
        this.$store.dispatch('pricing/FETCH_PRICING', true).catch(error => console.error(error))
      }

      await this.$store.dispatch('auth/FETCH_USER_INFO')

      await this.$router.push(route).catch(error => console.warn(error))
      return 'SUCCESS'
    },
  },
}

export default PurchaseResponseMixin
